// @ts-nocheck
import { CANCELLED_EVENT_ROW_SX, isCancelledEvent } from "../../utils/methods/eventPresentation";
import EventCancellationBadge from "../../components/Table/EventCancellationBadge";
import React from "react";
import { lazy } from "react";
import { useState } from "react";
import {
  Box,
  Button,
  Icon,
  Input,
  InputAdornment,
  TableSortLabel,
  Typography,
  Pagination,
  PaginationItem,
  useMediaQuery,
  Tooltip,
  ClickAwayListener,
  Chip,
  Divider,
} from "@mui/material";
import { Stack } from "@mui/system";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import WestIcon from "@mui/icons-material/West";
import SortArrow from "../../assets/images/sort-arrow.svg";
import AddPlus from "../../assets/images/add-plus.svg";
import Show from "../../assets/images/Show.svg";
import TableBody from "@mui/material/TableBody";
import { useTheme } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import DeletePink from "../../assets/images/Delete-pink.svg";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  ArrowBack,
  ArrowForward,
  Clear,
  Close,
  Search,
  Save,
  Info,
} from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useDashboardFilters } from "../../customHooks/useDashboardFilters";
import {
  extractFiltersFromState,
  applyFiltersToState,
  hasFiltersChanged,
  compareObjects,
} from "../../utils/dashboardFiltersUtils";
// import CreateEvent from "../create-event/CreateEvent";
const CreateEvent = lazy(() => import("../create-event/CreateEvent"));
import {
  archiveEventAction,
  deleteEventAction,
  fetchNewEventAction,
} from "../../store/actions/eventRequest";
import { confirmAndCloseCreateEventAction } from "../../store/actions/createEvent";
import { phoneNumberFormat } from "../../utils/methods/formatters";
import AssignClientModal from "./components/AssignClientModal";
import "./EventRequests.css";
import LoadingOverlay from "../../components/Custom/LoadingOverlay";

import { CongratulationsNavButtonsVariant2 } from "../create-event/components/event-details/EventDetails";
import dayjs from "dayjs";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import EditIcon from "../../assets/images/Edit-Square.svg";
import EditEventModal from "./components/EditEventModal";
import LineClamp from "../positions/components/LineClamp";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomDatePicker } from "../../components/Custom/DatePicker";
import { CalendarMonth } from "@mui/icons-material";
import { getUniversalDateTimeFormat } from "../../utils/methods/universalDateTimeFormat";
import GenericTransparentBtn from "../../components/Custom/GenericTransparentBtn";
import { inputRegex } from "../../utils/constants/inputRegex";
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import { ClientTool } from "../../components/Tooltip/ClientTool";
import { CustomDialog } from "../../components/Dialog/CustomDialog";
import { alertDialogAciton } from "../../store/actions/auth";
import RightClick from "../event-details/components/additionalComponents/RightClick";
import {
  handleEventContextMenu,
  onSubmitFormNoAction,
} from "../../utils/methods/eventUtils";
import { rejectEventAction } from "../../store/actions/estimate";
import { ClearAllTextButton } from "../../components/Filter/ClearAllTextButton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ...CANCELLED_EVENT_ROW_SX,
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  // "&:last-child td, &:last-child th": {
  //   border: 0,
  // },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginLeft: "10px",
  padding: "0px",
  borderRadius: "10px",
  // border: `1.5px solid ${getCssVariableHandler({
  //   variableName: "--font-rgb"
  // })}`,

  "&:hover": {
    backgroundColor: "rgba(209, 117, 182, 0.20)",
  },
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.MuiPaginationItem-root": {
    color: theme.palette.common.white,
  },
  "&.Mui-selected": {
    color: theme.palette.secondary.main,
  },
}));

const initialData = {
  search: "",
  sortOrder: "",
  sortField: "",
  dateRange: {
    startDate: "",
    endDate: "",
  },
  searchFilters: [],
  rowsPerPage: 25,
};

const initialFiltersDates = {
  status: false,
  startDate: "",
  endDate: "",
};

export const EventRequestClient = () => {
  const [isFilterInitialised, setIsFilterInitialised] = React.useState(false);
  const skipNextFetchRef = React.useRef(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  // Selectors start...
  const {
    eventRequests,
    totalPages,
    currentPage,
    isLoading,
    searchString,
    archiveLoading,
  } = useSelector((state) => state.eventRequest);
  const { isLoading: rejectLoading } = useSelector((state) => state.estimate);
  const { userRole } = useSelector((state) => state.auth);

  // Selectors end...

  // ====== EVENT REQUEST FILTERS MANAGEMENT ======
  const {
    originalFilters,
    savedFilters,
    isSaving,
    isDeleting,
    isLoading: isLoadingFilters,
    saveFilters,
    loadFilters,
    deleteFilters,
    updateFilters,
  } = useDashboardFilters("event-requests-client-dashboard");

  const [isFilterDataUpdated, setIsFilterDataUpdated] = React.useState(
    !compareObjects(
      originalFilters?.data?.filters,
      savedFilters?.data?.filters,
    ),
  );

  React.useEffect(() => {
    if (originalFilters) {
      setIsFilterDataUpdated(
        !compareObjects(
          originalFilters?.data?.filters,
          savedFilters?.data?.filters,
        ),
      );
    } else {
      setIsFilterDataUpdated(
        !compareObjects(initialData, savedFilters?.data?.filters),
      );
    }
  }, [savedFilters, originalFilters]);

  // Manual save filters handler (called by Save button)
  const handleSaveEventRequestFilters = () => {
    const currentFilters = extractFiltersFromState({
      filterParams: { ...filterParams, search: searchStr },
      filterDates,
      searchBy: [],
      rowsPerPage,
    });

    saveFilters(
      "event-requests-client-dashboard",
      currentFilters,
      () => {},
      (error) => {
        console.error("Error saving event request filters:", error);
      },
    );
  };

  // Function to clear saved filters
  const clearSavedEventRequestFiltersHandler = () => {
    const clearedFilterParams = {
      sortOrder: "",
      sortField: "",
    };

    setFilterParams(clearedFilterParams);
    setFilterDates(initialFiltersDates);
    setSearchStr("");
    setRowsPerPage(25);
    setPage(1);

    deleteFilters(
      "event-requests-client-dashboard",
      () => undefined,
      (error) => console.error("Error clearing event request filters:", error),
    );

    skipNextFetchRef.current = true;
    dispatch(
      fetchNewEventAction({
        payload: { role: userRole },
        params: {
          page: 1,
          limit: 25,
          eventName: "",
          ...clearedFilterParams,
        },
        successCallback: () => {},
      }),
    );
  };
  // ====== END EVENT REQUEST FILTERS MANAGEMENT ======

  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(currentPage || 1);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageInit);
  const [filterParams, setFilterParams] = useState({
    sortOrder: "",
    sortField: "",
  });
  const [filterDates, setFilterDates] = useState({
    status: false,
    startDate: "",
    endDate: "",
  });
  const [order, setOrder] = useState("asc");
  const [open, setOpen] = useState(false);
  const [searchStr, setSearchStr] = useState(searchString || "");
  const [eventInfo, setEventInfo] = useState(null);
  const [tab, setTab] = useState("EventRequests");

  const [editEventModal, setEditEventModal] = useState({
    status: false,
    data: null,
  });
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [deleteEventModal, setDeleteEventModal] = React.useState({
    status: false,
    id: null,
  });
  const [contextMenu, setContextMenu] = React.useState({
    status: false,
    mouseY: null,
    mouseX: null,
    row: null,
  });
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sma"));

  const fetchEventsHandler = ({ params, successCallback }) => {
    if (!isFilterInitialised) return;
    const { status, ...rest } = filterDates;
    dispatch(
      fetchNewEventAction({
        payload: {
          role: userRole,
        },
        params: {
          page,
          limit: rowsPerPage,
          eventName: searchStr,
          ...(filterParams || {}),
          ...(rest || {}),
          ...(params || {}),
        },
        additionalData: {
          searchString: searchStr,
          rowsPerPage,
          filtersDate: filterDates,
        },
        successCallback: () => {
          successCallback ? successCallback() : null;
        },
      }),
    );
  };

  function refreshNewEventRequest() {
    fetchEventsHandler({});
    // dispatch(fetchNewEventAction({
    //   payload: {
    //     role: userRole
    //   },
    //   params: {
    //     page: page,
    //     limit: rowsPerPage
    //   }
    // }));
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows?.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // if (!searchStr || searchStr === "") {
    //   dispatch(
    //     fetchNewEventAction({
    //       payload: {
    //         role: userRole
    //       },
    //       params: {
    //         page: newPage,
    //         limit: rowsPerPage
    //       },
    //       successCallback: () => {
    //         setPage(newPage);
    //       }
    //     })
    //   );
    // } else {
    //   dispatch(
    //     searchNewEventsAction(
    //       { role: userRole, page: newPage, searchStr },
    //       () => {
    //         setPage(newPage);
    //       },
    //     ),
    //   );
    // }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleSortRequest = ({ cb, field }) => {
    const newOrder = filterParams?.sortOrder === "asc" ? "desc" : "asc";
    setFilterParams((filterParams) => {
      return {
        ...filterParams,
        sortOrder: newOrder,
        sortField: field,
      };
    });
    // const sortedRows = [...rows].sort((a, b) => {
    //   const aValue = cb({ row: a });
    //   const bValue = cb({ row: b });

    //   if (newOrder === "asc") {
    //     if (aValue < bValue) {
    //       return -1;
    //     }
    //     if (aValue > bValue) {
    //       return 1;
    //     }
    //     return 0;
    //   } else {
    //     if (aValue < bValue) {
    //       return 1;
    //     }
    //     if (aValue > bValue) {
    //       return -1;
    //     }
    //     return 0;
    //   }
    // });
    // setRows(sortedRows);
    // setOrder(newOrder);
  };

  const handleSearch = (e) => {
    // const searchStr = e.target.value;
    // if (!searchStr || searchStr === "") {
    //   dispatch(fetchNewEventAction({ role: userRole }));
    // } else {
    //   dispatch(searchNewEventsAction({ role: userRole, eventName: searchStr }));
    // }
    const value = e?.target?.value?.replace(inputRegex, "");
    setSearchStr(value);
  };

  // Back arrow of the Create Event tab: asks before discarding the build
  // in progress (steps already completed stay under the draft events).
  const closeCreateEventTabHandler = () => {
    dispatch(
      confirmAndCloseCreateEventAction(() => {
        setTab("EventRequests");
      }),
    );
  };

  // Load filters on component mount
  React.useEffect(() => {
    if (eventRequests?.length > 0 || totalPages === 0) {
      setIsFilterInitialised(true);
      return;
    }

    loadFilters(
      "event-requests-client-dashboard",
      (savedFiltersData) => {
        const { data } = savedFiltersData || {};
        if (!data || (Object.keys(data).length === 0 && !data.filters)) {
          setIsFilterInitialised(true);
        }
      },
      (error) => {
        setIsFilterInitialised(true);
      },
    );
  }, []);

  // ====== EVENT REQUEST FILTERS USEEFFECT HOOKS ======

  // Watch for changes in savedFilters from Redux store
  React.useEffect(() => {
    const { data } = savedFilters || {};

    if (data && (data?.filters || Object.keys(data).length > 0)) {
      const appliedFilters = applyFiltersToState(data);

      if (appliedFilters) {
        // Apply filter params
        setFilterParams((prev) => ({
          ...prev,
          sortOrder: appliedFilters.filterParams?.sortOrder || prev.sortOrder,
          sortField: appliedFilters.filterParams?.sortField || prev.sortField,
        }));

        // Apply filter dates
        if (
          appliedFilters.filterDates?.startDate ||
          appliedFilters.filterDates?.endDate
        ) {
          setFilterDates(appliedFilters.filterDates);
        }

        // Apply search filters
        if (appliedFilters.filterParams?.search) {
          setSearchStr(appliedFilters.filterParams?.search || "");
        }

        // Apply rows per page
        if (appliedFilters.rowsPerPage) {
          setRowsPerPage(appliedFilters.rowsPerPage);
        }
      }
      setIsFilterInitialised(true);
    }
  }, [savedFilters]);

  // ====== END EVENT REQUEST FILTERS USEEFFECT HOOKS ======

  // Consolidated effect for fetching table data
  React.useEffect(() => {
    // Only proceed if filters have been initialised
    if (!isFilterInitialised) return;

    if (skipNextFetchRef.current) {
      skipNextFetchRef.current = false;
      return;
    }

    const currentFilters = extractFiltersFromState({
      filterParams: { ...filterParams, search: searchStr },
      filterDates,
      searchBy: [],
      rowsPerPage,
    });

    const savedData = savedFilters?.data;
    // Skip API call only if:
    // 1. Dashboard already has data, AND
    // 2. Filters are initialized, AND
    // 3. Filters haven't changed, AND
    // 4. Page matches the currentPage in Redux (pagination triggers when page !== currentPage)
    const isPageUnchanged = page === currentPage;

    // Optional optimization: skip if data exists and filters match
    if (
      (!!eventRequests.length || totalPages == 0) &&
      isFilterInitialised &&
      !hasFiltersChanged(currentFilters, savedData) &&
      isPageUnchanged
    ) {
      return;
    }

    // Use a small debounce to catch multiple state updates at once (e.g. from saved filters)
    const timeout = setTimeout(() => {
      fetchEventsHandler({});

      if (!isFilterInitialised) return;

      const currentFilters = extractFiltersFromState({
        filterParams: { ...filterParams, search: searchStr },
        filterDates,
        searchBy: [],
        rowsPerPage,
      });

      const savedData = savedFilters?.data;

      // Only update Redux if the filters have actually changed
      if (hasFiltersChanged(currentFilters, savedData)) {
        updateFilters("event-requests-client-dashboard", {
          data: { filters: currentFilters },
        });
      }
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [
    isFilterInitialised,
    page,
    rowsPerPage,
    filterParams?.sortField,
    filterParams?.sortOrder,
    searchStr,
    filterDates?.startDate,
    filterDates?.endDate,
    tab,
  ]);

  // Handle page reset when filters change
  React.useEffect(() => {
    if (!isFilterInitialised) return;
    if (page !== 1) {
      setPage(1);
    }
  }, [
    rowsPerPage,
    filterParams?.sortField,
    filterParams?.sortOrder,
    searchStr,
    filterDates?.startDate,
    filterDates?.endDate,
    tab,
  ]);

  React.useEffect(() => {
    setRows(eventRequests);
  }, [eventRequests]);

  return (
    <>
      {tab === "EventRequests" ? (
        <>
          <Box
            sx={{
              padding: "20px 40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              "@media (max-width: 600px)": {
                flexDirection: "column",
                padding: "20px 20px",
              },
            }}
          >
            <Typography
              variant={isSmallScreen ? "h3" : "h1"}
              sx={{
                "@media (max-width: 600px)": {
                  marginBottom: "15px",
                },
              }}
            >
              Event Requests
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                "& .MuiInputBase-root": {
                  border: "1px solid #FFF !important",
                  background: "rgba(0, 0, 0, 0.01) !important",
                  boxShadow:
                    "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
                  borderRadius: "8px",
                  padding: "5px 24px 5px 16px",
                  "&:before": {
                    content: "none",
                  },
                  "&:after": {
                    content: "none",
                  },
                  "& svg": {
                    color: "#ffffff",
                  },
                  "& input": {
                    color: "#ffffff",
                  },
                },
              }}
            >
              <Tooltip
                open={filterDates?.status}
                PopperProps={{
                  sx: {
                    zIndex: "1200",
                  },
                }}
                title={
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1rem",
                        padding: "0.25rem",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "0.5rem",
                        }}
                      >
                        <Typography className="no-wrap">Start Date:</Typography>
                        <CustomDatePicker
                          name="startDate"
                          onChange={(date) => {
                            // setFieldValue("eventStart", date?.format("YYYY-MM-DD"));
                            if (!date) return;
                            setFilterDates((searchFilters) => {
                              return {
                                ...searchFilters,
                                startDate: date?.format("YYYY-MM-DD"),
                              };
                            });
                          }}
                          sx={{
                            "& fieldset": {
                              paddingLeft: "0.25rem",
                              paddingRight: "0.25rem",
                            },
                            padding: "0 0.5rem",
                            border: "none !important",
                            height: "2.5rem",
                            width: "14rem !important",
                          }}
                          slotProps={{
                            textField: { placeholder: "Start date" },
                            actionBar: {
                              actions: ["clear"],
                            },
                          }}
                          defaultValue={dayjs(filterDates?.startDate || "")}
                          // format={
                          //   filterDates?.startDate
                          //     ? "ddd MM/DD/YYYY"
                          //     : "MM/DD/YYYY"
                          // }
                        />
                      </Box>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "0.5rem",
                        }}
                      >
                        <Typography className={"no-wrap"}>
                          End Date: &nbsp;
                        </Typography>
                        <CustomDatePicker
                          name="endDate"
                          onChange={(date) => {
                            // setFieldValue("eventStart", date?.format("YYYY-MM-DD"));
                            if (!date) return;
                            setFilterDates((searchFilters) => {
                              return {
                                ...searchFilters,
                                endDate: date?.format("YYYY-MM-DD"),
                              };
                            });
                          }}
                          sx={{
                            "& fieldset": {
                              paddingLeft: "0.25rem",
                              paddingRight: "0.25rem",
                            },
                            padding: "0 0.5rem",
                            border: "none !important",
                            height: "2.5rem",
                            width: "14rem !important",
                          }}
                          slotProps={{
                            textField: { placeholder: "End date" },
                            actionBar: {
                              actions: ["clear"],
                            },
                          }}
                          // value={dayjs(values.eventStart)}
                          defaultValue={dayjs(filterDates?.endDate || "")}
                          // format={
                          //   filterDates?.endDate
                          //     ? "ddd MM/DD/YYYY"
                          //     : "MM/DD/YYYY"
                          // }
                        />
                      </Box>
                    </Box>
                  </LocalizationProvider>
                }
              >
                <IconButton
                  sx={{
                    marginRight: "10px",
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                    height: "2.25rem",
                    width: "2.25rem",
                  }}
                  onClick={(e) => {
                    setFilterDates((prev) => ({
                      ...prev,
                      status: !prev.status,
                    }));
                  }}
                >
                  <CalendarMonth
                    sx={{
                      color: "#FFF",
                    }}
                  />
                </IconButton>
              </Tooltip>
              <form autoComplete="off" onSubmit={onSubmitFormNoAction}>
                <Input
                  id="input-with-icon-adornment"
                  onChange={handleSearch}
                  value={searchStr}
                  placeholder="Search here"
                  // startAdornment={
                  //   <InputAdornment position="start">
                  //     <Search />
                  //   </InputAdornment>
                  // }
                  endAdornment={
                    <InputAdornment position="start">
                      {!searchStr ? (
                        <Search
                          sx={{
                            fontSize: "1.25rem",
                            // marginRight: "0.7rem"
                          }}
                        />
                      ) : (
                        <GenericTransparentBtn
                          onClick={() => {
                            setSearchStr("");
                          }}
                          style={{
                            background: "grey",
                            padding: "0.10rem",
                            borderRadius: "50%",
                            onHover: {
                              background: "grey",
                              padding: "0.10rem",
                            },
                          }}
                        >
                          <Close
                            sx={{
                              fontSize: "1rem",
                              // marginRight: "0.7rem"
                            }}
                          />
                        </GenericTransparentBtn>
                      )}
                    </InputAdornment>
                  }
                  sx={{
                    paddingLeft: "1rem !important",
                    border: "1px solid #FFF !important",
                    "@media (max-width: 1000px)": {
                      flexGrow: "1",
                      // width: "70%"
                    },
                  }}
                />
              </form>

              <Tooltip title={"Create new event"}>
                <Button
                  sx={{
                    marginLeft: "10px",
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                  }}
                  onClick={(e) => {
                    // dispatch(resetCreateEventSlice());
                    // navigate(`/create-event`);
                    setTab("CreateEvent");
                  }}
                >
                  <img src={AddPlus} />
                </Button>
              </Tooltip>

              <Tooltip title={"Save filters"}>
                <Button
                  disabled={isSaving}
                  sx={{
                    marginLeft: "10px",
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "2.25rem",
                    height: "2.25rem",
                  }}
                  onClick={handleSaveEventRequestFilters}
                >
                  {isSaving ? (
                    <CircularProgress size={20} sx={{ color: "#FFF" }} />
                  ) : (
                    <Save sx={{ color: "#FFF" }} />
                  )}
                </Button>
              </Tooltip>

              {/* Currently Applied Filters */}
              <Tooltip
                title={
                  <Box
                    sx={{
                      maxWidth: 400,
                      maxHeight: 600,
                      overflowY: "auto",
                      p: 1,
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold">
                      Currently Applied Filters
                    </Typography>
                    {/* un saved filters */}
                    {!!isFilterDataUpdated && (
                      <>
                        <Typography
                          variant="caption"
                          fontWeight="300"
                          color="warning.main"
                          mb={1}
                        >
                          You have unsaved filter changes
                        </Typography>
                      </>
                    )}
                    <Divider color="#8F00FF" sx={{ mb: 1 }} />

                    {/* Dates */}
                    <Typography variant="caption" fontWeight="bold">
                      Dates
                    </Typography>
                    <Stack spacing={0.25} mb={1}>
                      {filterDates?.startDate || filterDates?.endDate ? (
                        <>
                          {filterDates?.startDate && (
                            <Typography variant="body2">
                              Start:{" "}
                              {dayjs(filterDates.startDate).format(
                                "MM/DD/YYYY",
                              )}
                            </Typography>
                          )}
                          {filterDates?.endDate && (
                            <Typography variant="body2">
                              End:{" "}
                              {dayjs(filterDates.endDate).format("MM/DD/YYYY")}
                            </Typography>
                          )}
                        </>
                      ) : (
                        <Typography variant="body2">No date filter</Typography>
                      )}
                    </Stack>

                    {/* Search */}
                    <Typography variant="caption" fontWeight="bold">
                      Search
                    </Typography>
                    <Typography variant="body2" mb={1}>
                      {searchStr || "None"}
                    </Typography>

                    {/* Sort */}
                    <Typography variant="caption" fontWeight="bold">
                      Sort
                    </Typography>
                    <Typography variant="body2" mb={1}>
                      {filterParams?.sortField
                        ? `${filterParams.sortField} (${filterParams.sortOrder})`
                        : "None"}
                    </Typography>

                    {/* Rows */}
                    <Typography variant="caption" fontWeight="bold">
                      Rows Per Page
                    </Typography>
                    <Typography variant="body2" mb={1}>
                      {rowsPerPage === 10000000000 ? "All" : rowsPerPage}
                    </Typography>

                    <Divider color="#8F00FF" sx={{ my: 1 }} />

                    {/* Clear */}
                    <Box display="flex" justifyContent="center">
                      <ClearAllTextButton
                        onClear={clearSavedEventRequestFiltersHandler}
                      />
                    </Box>
                  </Box>
                }
              >
                <IconButton
                  sx={{
                    marginLeft: "10px",
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                    width: "2.25rem",
                    height: "2.25rem",
                  }}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <CircularProgress size={20} sx={{ color: "white" }} />
                  ) : (
                    <Info sx={{ color: "#FFF" }} />
                  )}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <Box>
            {isLoading ||
            archiveLoading ||
            rejectLoading ||
            eventRequests !== rows ? (
              <LoadingOverlay open={true} />
            ) : (
              <Box>
                <TableContainer
                  className="custom-scroll-design"
                  sx={{
                    maxWidth: "100%",
                    ...(isSmallScreen
                      ? {
                          minHeight: "calc(100vh - 323px)",
                        }
                      : {
                          height: "88vh",
                        }),
                    overscrollBehavior: "auto",
                  }}
                >
                  <Table sx={{}} aria-label="sticky table" stickyHeader>
                    <TableHead>
                      <TableRow
                        sx={{
                          "& th": {
                            backgroundColor: "#D175B6 !important",
                            padding: "2px 15px",
                            fontSize: "20px",
                            color: "#ffffff",
                            borderColor: "#D175B6",
                            "& span": {
                              color: "#ffffff !important",
                            },
                          },
                          "& th:not(:last-child)": {
                            paddingRight: "0 !important",
                          },
                        }}
                      >
                        <StyledTableCell
                          sx={{
                            minWidth: "6rem",
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              padding: "2px 0 2px 35px",
                              textWrap: "nowrap",
                              // fontSize: "1rem !important"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "eventName"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.eventName;
                                },
                                field: "eventName",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Event Name
                          </TableSortLabel>
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            minWidth: "6rem",
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              textWrap: "nowrap",
                              // fontSize: "1rem !important"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "eventEnd"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.eventStart;
                                },
                                field: "eventStart",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Event Start
                          </TableSortLabel>
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            minWidth: "6rem",
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              textWrap: "nowrap",
                              // fontSize: "1rem !important"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "eventEnd"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.eventEnd;
                                },
                                field: "eventEnd",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Event End
                          </TableSortLabel>
                        </StyledTableCell>
                        {isActiveRole(USER_ROLES.COORDINATOR) ? null : (
                          <StyledTableCell
                            sx={{
                              minWidth: "10rem",
                              textAlign: "center",
                              // fontSize: "1rem !important"
                            }}
                          >
                            Client Name
                          </StyledTableCell>
                        )}
                        {isActiveRole(USER_ROLES.COORDINATOR) ? null : (
                          <StyledTableCell
                            sx={{
                              minWidth: "10rem",
                              // fontSize: "1rem !important"
                            }}
                          >
                            Event Contact
                          </StyledTableCell>
                        )}
                        <StyledTableCell
                          sx={{
                            minWidth: "15rem",
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              textWrap: "nowrap",
                              // fontSize: "1rem !important"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "venue"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.venue;
                                },
                                field: "venue",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Venue
                          </TableSortLabel>
                        </StyledTableCell>
                        {isUserRole(
                          USER_ROLES.CLIENT,
                          USER_ROLES.COORDINATOR,
                        ) ? (
                          <StyledTableCell></StyledTableCell>
                        ) : null}
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        "& td": {
                          borderColor: "#D175B6",
                          color: "#ffffff",
                          "& td": {},
                        },
                        "& td:not(:last-child)": {
                          paddingRight: "0 !important",
                        },
                      }}
                    >
                      {rows?.map((row, index) => (
                        <StyledTableRow
                          data-cancelled={isCancelledEvent(row) ? "true" : undefined} key={index}>
                          <StyledTableCell>
                            <Typography
                              onContextMenu={(event) => {
                                handleEventContextMenu({
                                  event,
                                  row,
                                  setContextMenu,
                                });
                              }}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                textWrap: "nowrap",
                                "& a": {
                                  lineHeight: "0",
                                },
                                "& img": {
                                  marginRight: "10px",
                                },
                              }}
                            >
                              <Link
                                to="/event/new-request/details"
                                state={{
                                  id: row?._id,
                                  contactId: row?.contactInformationId,
                                  coordinatorId: row?.assignedCoordinatorId[0]
                                    ? row?.assignedCoordinatorId[0]
                                    : null,
                                }}
                              >
                                <img src={Show} />
                              </Link>
                              {row?.eventName}
                              <EventCancellationBadge event={row} />
                              {row?.isRejected ? (
                                <>
                                  <StyledIconButton
                                    color="primary"
                                    disabled={true}
                                  >
                                    <Clear color="primary" />
                                  </StyledIconButton>
                                </>
                              ) : null}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Typography
                              sx={{
                                textWrap: "nowrap",
                              }}
                            >
                              {getUniversalDateTimeFormat({
                                dateTime: row?.eventStart,
                              })}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell>
                            <Typography
                              sx={{
                                textWrap: "nowrap",
                              }}
                            >
                              {getUniversalDateTimeFormat({
                                dateTime: row?.eventEnd,
                              })}
                            </Typography>
                          </StyledTableCell>
                          {isActiveRole(USER_ROLES.COORDINATOR) ? null : (
                            <StyledTableCell>
                              <ClientTool
                                disable={!row?.userId}
                                data={row?.clientDetail}
                              >
                                <Typography
                                  sx={{
                                    wordBreak: "break-all",
                                    textAlign: "center",
                                    // textWrap: "nowrap",
                                  }}
                                >
                                  {row?.userId ? (
                                    row?.clientDetail?.companyName ? (
                                      row?.clientDetail?.companyName
                                    ) : (
                                      row?.clientDetail?.firstName +
                                      " " +
                                      row?.clientDetail?.lastName
                                    )
                                  ) : isActiveRole(USER_ROLES.COORDINATOR) ? (
                                    "No Client Added"
                                  ) : (
                                    <span
                                      className="assign_client"
                                      onClick={() => {
                                        setEventInfo({
                                          contactInfo: row?.contactInformation,
                                          eventId: row?._id,
                                        });
                                        setOpen(true);
                                      }}
                                    >
                                      Assign Client
                                    </span>
                                  )}
                                </Typography>
                              </ClientTool>
                            </StyledTableCell>
                          )}
                          {isActiveRole(USER_ROLES.COORDINATOR) ? null : (
                            <StyledTableCell>
                              <ClientTool data={row?.contactInformation}>
                                <Typography
                                  sx={{
                                    wordBreak: "break-all",
                                    textAlign: "center",
                                    // textWrap: "wrap",
                                  }}
                                >
                                  {row?.contactInformation?.companyName
                                    ? row?.contactInformation?.companyName
                                    : row?.contactInformation?.firstName +
                                      " " +
                                      row?.contactInformation?.lastName}
                                </Typography>
                              </ClientTool>
                            </StyledTableCell>
                          )}
                          <StyledTableCell>
                            <Tooltip
                              title={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                            >
                              <Typography>
                                <LineClamp
                                  text={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                                  maxLines={1}
                                />
                              </Typography>
                            </Tooltip>
                          </StyledTableCell>
                          {isUserRole(
                            USER_ROLES.CLIENT,
                            USER_ROLES.COORDINATOR,
                          ) ? (
                            <StyledTableCell
                              sx={{
                                display: "table-cell",
                                // display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                // padding: "10px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <Tooltip title={"Edit event"}>
                                  <Button
                                    variant="text"
                                    onClick={() => {
                                      setEditEventModal({
                                        status: true,
                                        data: row,
                                      });
                                    }}
                                    sx={{
                                      backgroundColor: "#C369A7",
                                      padding: "10px 10px",
                                      width: "auto",
                                      minWidth: "auto",
                                      ":hover": {
                                        backgroundColor: "#C369A7",
                                      },
                                    }}
                                  >
                                    <img src={EditIcon} />
                                  </Button>
                                </Tooltip>

                                {isActiveRole(USER_ROLES.CLIENT) && (
                                  <Tooltip title={"Cancel Event"}>
                                    <Button
                                      variant="text"
                                      sx={{
                                        backgroundColor: "#FFF",
                                        padding: "10px 10px",
                                        width: "auto",
                                        minWidth: "auto",
                                        ":hover": {
                                          backgroundColor: "#FFF",
                                        },
                                      }}
                                      onClick={() => {
                                        dispatch(
                                          alertDialogAciton({
                                            open: true,
                                            title: "Warning",
                                            message:
                                              "Are you sure, you want to cancel this event request? This action cannot be undone.",
                                            okLabel: "Cancel Event",
                                            onOk: () => {
                                              dispatch(
                                                rejectEventAction(
                                                  { eventId: row?._id },
                                                  () => {
                                                    fetchEventsHandler({});
                                                  },
                                                ),
                                              );
                                            },
                                          }),
                                        );
                                      }}
                                    >
                                      <Close sx={{ fontSize: "1.125rem" }} />
                                    </Button>
                                  </Tooltip>
                                )}

                                {isActiveRole(USER_ROLES.COORDINATOR) && (
                                  <Tooltip title={"Delete event"}>
                                    <Button
                                      variant="text"
                                      sx={{
                                        backgroundColor: "#FFF",
                                        padding: "10px 10px",
                                        width: "auto",
                                        minWidth: "auto",
                                        ":hover": {
                                          backgroundColor: "#FFF",
                                        },
                                      }}
                                      onClick={() => {
                                        setDeleteEventModal({
                                          status: true,
                                          id: row?._id,
                                        });
                                      }}
                                    >
                                      <img src={DeletePink} />
                                    </Button>
                                  </Tooltip>
                                )}
                              </Box>
                            </StyledTableCell>
                          ) : null}
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  sx={{
                    "& td": {
                      display: "block",
                    },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "black",
                    borderRadius: "0px 0px 15px 15px",
                    borderTop: "1px solid #D175B6",
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handleChangePage}
                    siblingCount={isSmallScreen ? 0 : 1}
                    renderItem={(item) => (
                      <StyledPaginationItem
                        slots={{ previous: ArrowBack, next: ArrowForward }}
                        {...item}
                      />
                    )}
                  />
                </Box>
              </Box>
            )}
          </Box>

          {/* Edit event modal*/}
          {editEventModal?.status && (
            <EditEventModal
              eventData={editEventModal.data}
              open={editEventModal.status}
              handleClose={() => {
                setEditEventModal({ status: false, data: null });
              }}
              updateEvent={() => {
                fetchEventsHandler({});
              }}
            />
          )}
        </>
      ) : (
        <>
          <Box
            sx={{
              position: "relative",
            }}
          >
            <Box
              sx={{
                padding: "0.75rem 0 0 0.75rem",
                // position: 'absolute',
                // top: '0',
                // left: '0',
                // display: 'flex',
                // justifyContent: 'flex-end',
              }}
            >
              <Button
                onClick={closeCreateEventTabHandler}
                sx={{
                  minWidth: "0",
                  background: "none",
                  padding: "0.5rem",
                  boxShadow: "none",
                  border: `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })}`,
                  borderRadius: "50%",
                  "&:hover": {
                    minWidth: "0",
                    background: "none",
                    padding: "0.5rem",
                    boxShadow: "none",
                    border: `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })}`,
                    borderRadius: "50%",
                  },
                }}
              >
                <WestIcon />
              </Button>
            </Box>

            <CreateEvent
              showNavigationButtons={false}
              closeHandler={closeCreateEventTabHandler}
              NavButtonsComponent={CongratulationsNavButtonsVariant2}
              navButtonsComponentProps={{
                closeHandler: closeCreateEventTabHandler,
              }}
            />
          </Box>
        </>
      )}

      <AssignClientModal
        refreshNewEventRequest={refreshNewEventRequest}
        open={open}
        setOpen={setOpen}
        eventInfo={eventInfo}
        isList={true}
      />
      {/* custom dialog for delete event */}
      <CustomDialog
        open={deleteEventModal.status}
        onClose={() => {
          setDeleteEventModal({ status: false, id: null });
          setConfirmPassword("");
        }}
        title="Delete Event"
        message="Are you sure you want to delete this event?"
        okLabel="Delete"
        onOk={() => {
          dispatch(
            deleteEventAction({
              payload: {
                eventId: deleteEventModal.id,
                data: {
                  confirmationPassword: confirmPassword,
                },
              },
              successCallback: () => {
                setDeleteEventModal({ status: false, id: null });
                setConfirmPassword("");
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Success",
                    message: "Event deleted successfully.",
                  }),
                );
                fetchEventsHandler({});
              },
            }),
          );
        }}
        confirmPassword={true}
        password={confirmPassword}
        setPassword={setConfirmPassword}
      />

      {isActiveRole(USER_ROLES.COORDINATOR) && (
        <RightClick
          clickEvents={{
            archiveEvent: () => {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Warning",
                  message: "Are you sure, you want to archive this event?",
                  okLabel: "Archive Event",
                  onOk: () => {
                    dispatch(
                      archiveEventAction({
                        payload: {
                          params: {
                            eventId: contextMenu?.row?._id,
                          },
                        },
                        successCallback: () => {
                          fetchEventsHandler({});
                        },
                      }),
                    );

                    setContextMenu({
                      status: false,
                      mouseX: null,
                      mouseY: null,
                      row: null,
                    });
                  },
                }),
              );
            },
            editEvent: () => {
              setEditEventModal({
                status: true,
                data: contextMenu?.row,
              });
              setContextMenu({
                status: false,
                mouseX: null,
                mouseY: null,
                row: null,
              });
            },
            deleteEvent: () => {
              setDeleteEventModal({
                status: true,
                id: contextMenu?.row?._id,
              });
              setContextMenu({
                status: false,
                mouseX: null,
                mouseY: null,
                row: null,
              });
            },
          }}
          contextMenu={contextMenu}
          handleClose={() =>
            setContextMenu({
              status: false,
              mouseX: null,
              mouseY: null,
              row: null,
            })
          }
        />
      )}
    </>
  );
};
